import * as React from "react";
import styled from "styled-components";
import { SearchForm } from "security-app/components/common";
import { usePagination, useSetPagination } from "common/contexts";
import BulkActions from "./BulkActions";
const Container = styled.div`
  margin-bottom: 24px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
const ButtonsRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.6rem;
`;
function SearchRow({ hideSearchForm = false, visibleBulkActions = void 0 }) {
  const pagination = usePagination();
  const setPagination = useSetPagination();
  const onSearch = (query = null) => {
    setPagination({ ...pagination, page: 1, query });
  };
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(ButtonsRow, null, /* @__PURE__ */ React.createElement(BulkActions, { visibleBulkActions })), hideSearchForm || /* @__PURE__ */ React.createElement("div", { style: { marginLeft: "auto" } }, /* @__PURE__ */ React.createElement(SearchForm, { onSearch, onReset: onSearch, placeholder: "Search for a rule..." })));
}
export default SearchRow;
